import API from '~/apis/client'

export async function getAll(params: any) {
  return await API.handle(
    API.private.get<any>(`/customer/v1/order_histories`, { params })
  )
}
